const DEFAULT_BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH || '/templates'

const BASE_PATH_MAP = {
  fr: '/modeles',
  es: '/plantillas',
  pt: '/modelos',
  it: '/modelli',
}

const getBasePath = (locale: string): string => BASE_PATH_MAP[locale] || DEFAULT_BASE_PATH

export default getBasePath
